<template>
<div>
  <v-snackbar
    color="#000000b3"
    timeout="-1"
    v-model="showOffline">
      <div   class="no-connection d-flex  justify-space-between">
        <div style="width:95%" class="text-center">
          {{ $t("offlineNotification.offlineMessage") }}
        </div>
        <div>
          <v-btn  x-small icon class="close-btn pb-1" @click="showOffline = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
  </v-snackbar>
  <v-snackbar
    color="#4caf50b3"
    timeout="-1"
    v-model="showOnline">
        <div  class="connection-restored  d-flex  justify-space-between">
          <div style="width:95%" class="text-center">
            {{ $t("offlineNotification.onlineMessage") }}
          </div>
          <div>
            <v-btn x-small icon class="close-btn pb-1"  @click="showOnline = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div> 
        </div>
  </v-snackbar>        
</div>
</template>
  
<script lang="ts">
  import ViewModel from "./OfflineNotification"
  export default ViewModel;
</script>
    
<style lang="scss" scoped>
.close-btn
{
  color: white !important;
}
.no-connection
  {
    //background-color: #000000b3 !important;
     color: white !important;
     width: 100%;
  }

.connection-restored
{
  //background-color: #4caf50b3 !important;
  color: white !important;
  width: 100%;
}
.overlay {
      position: fixed;
      width: 100%;
      height: 25px;
      left: 0;
      right: 0;
      bottom: 86px;
      z-index: 100000;
      cursor: pointer;
  }

  .v-dialog{
    overflow-y: clip !important;
  }
  
  </style>  